import { render, staticRenderFns } from "./CreatePotSetup.vue?vue&type=template&id=c4933c42&"
import script from "./CreatePotSetup.vue?vue&type=script&lang=js&"
export * from "./CreatePotSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports